import axios from "axios";
import React, { useEffect, useState } from "react";
import "./modal.css";
import { Link } from "react-router-dom";
import LoaderBuildWishList from "../../Components/pageLoader/LoaderBuildWishList";

const BuildWishlist = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true); // Loader state

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get("https://server-gs.vercel.app/category");
        setCategories(response.data);
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    };

    // Fetch data immediately and then set interval
    fetchCategories();
    const intervalId = setInterval(fetchCategories, 1000); // Fetch every 2 seconds

    // Clear the interval when component unmounts
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className=" bg-rose-50 ">
      <div className="max-w-screen-2xl mx-auto 0  p-4">
        <div className="flex flex-col justify-center items-center ">
          <h1 className="text-center font-pacifico font-thin text-6xl text-rose-700 py-20">
            Build Your Wishlist
          </h1>
          <div
            className="h-1 w-full "
            style={{
              background:
                "linear-gradient(to right, transparent, #6B021A, transparent)",
            }}
          ></div>
          <h1 className="text-4xl font-raleway mt-10 font-semibold text-rose-900">
            Let’s shop!
          </h1>
          <h2 className="text-xl font-raleway my-10 text-rose-800">
            Heart the items you love, check out, and within 1-2 days, one of our
            Event Specialists will send you a proposal or contact you for more
            information!
          </h2>
          {loading ? (
            <LoaderBuildWishList></LoaderBuildWishList>
          ) : (
            <div className="grid grid-cols-5 gap-5 mb-10 w-full">
              {categories.map((event) => (
                <Link to={`/rental-all-products/${event.catValue}`}>
                  <div className="relative h-[200px] w-full">
                    {/* Video Background */}

                    <img
                      className="absolute inset-0 w-full h-full object-cover"
                      src={event.singleImage}
                      alt=""
                    ></img>

                    {/* Overlay */}
                    <div className="absolute inset-0 bg-black opacity-50"></div>

                    {/* Content */}
                    <section className="relative z-10 h-full">
                      <div className="flex justify-center flex-col items-center h-full">
                        <h1 className="text-white text-2xl  font-raleway">
                          {event.category}
                        </h1>
                      </div>
                    </section>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BuildWishlist;
